import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  PostFormData,
} from "../../../services/apiMethod";

export const BlogEndpoint = {
  getBlog: `/admin/get-blogs-home`,
  getBlogByID: `/admin/get-single-blog`,
  addBlog: `/admin/create-blog`,
  deleteBlog: `/admin/delete-blog/`,
  editBlog: `/admin/update-blog/`,
  addBlogCategory: `/admin/create-blog-category`,
  getBlogCategory: `/admin/get-all-blog-category`,
  updateBlogCategory: `/admin/update-blog-category/`,
  deleteBlogCategory: `/admin/delete-blog-category/`,
};

export const getBlog = (param = "") => {
  const url = getAPIUrl(BlogEndpoint.getBlog, param);
  return Get(url, true);
};
export const getBlogByID = (param = "") => {
  const url = getAPIUrl(BlogEndpoint.getBlogByID, param);
  return Get(url, true);
};
export const getBlogCategory = (param = "") => {
  const url = getAPIUrl(BlogEndpoint.getBlogCategory, param);
  return Get(url, true);
};
export const addBlog = (data, param = "") => {
  const url = getAPIUrl(BlogEndpoint.addBlog, param);
  return PostFormData(url, data, true);
};
export const addBlogCategory = (data, param = "") => {
  const url = getAPIUrl(BlogEndpoint.addBlogCategory, param);
  return Post(url, data, true);
};
export const updateBlogCategory = (data, param = "") => {
  const url = getAPIUrl(BlogEndpoint.updateBlogCategory, param);
  return Post(url, data, true);
};
export const editBlog = (data, param = "") => {
  const url = getAPIUrl(BlogEndpoint.editBlog, param);
  return PostFormData(url, data, true);
};
export const deleteBlog = (param = "") => {
  const url = getAPIUrl(BlogEndpoint.deleteBlog, param);
  return Delete(url, param);
};
export const deleteBlogCategory = (param = "") => {
  const url = getAPIUrl(BlogEndpoint.deleteBlogCategory, param);
  return Post(url);
};
export const modifyHighlightedStatus = (data, param = "") => {
  const url = getAPIUrl(BlogEndpoint.modifyHighlightedStatus, param);
  return Post(url, data, true);
};
